module.exports = __webpack_public_path__ + "img/search-header-nav-below-chevy.893d31f0.png";